var map = {
	"./texaspoke_en.png": "0gk+",
	"./texaspoke_th.png": "Bofd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "99pm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas ^\.\/texaspoke_.*\.png$
// module id = 99pm
// module chunks = 1